"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PropertyCondition {
    constructor(property) {
        this.isOptional = false;
        this.isNullable = false;
        this.property = property;
    }
    setOptions(options) {
        this.options = options;
    }
    getProperty() {
        return this.property;
    }
    optional() {
        this.isOptional = true;
        return this;
    }
    nullable() {
        this.isNullable = true;
        return this;
    }
    checkProperty(value) {
        if (value[this.property] === undefined) {
            if (this.isOptional) {
                return { result: { fulfilled: true }, isFinal: true };
            }
            return { result: this.createUnfulfilledResult(value, PropertyCondition.EXPLANATION_UNDEFINED), isFinal: true };
        }
        if (value[this.property] === null) {
            if (this.isNullable) {
                return { result: { fulfilled: true }, isFinal: true };
            }
            return { result: this.createUnfulfilledResult(value, PropertyCondition.EXPLANATION_NULL), isFinal: true };
        }
        return { result: { fulfilled: true }, isFinal: false };
    }
    createUnfulfilledResult(value, explanation) {
        return { fulfilled: false, reasons: [{ path: this.property, value: value[this.property], explanation }] };
    }
    passesNullOrUndefined(value) {
        return (value[this.property] === undefined && this.isOptional) || (value[this.property] === null && this.isNullable);
    }
}
exports.PropertyCondition = PropertyCondition;
PropertyCondition.EXPLANATION_UNDEFINED = "is undefined";
PropertyCondition.EXPLANATION_NULL = "is null";
//# sourceMappingURL=PropertyCondition.js.map